export const timePanelHeaderText = "ZBa";
export const meetNowHeaderText = "_Ba";
export const groupsPanelHeaderText = "$Ba";
export default {timePanelHeaderText,meetNowHeaderText,groupsPanelHeaderText};